import IDataNotFound from "../../../../shared/interfaces/data-not-found.interface";


export const DATA_NOT_FOUND: IDataNotFound = {
    title: "Ups! Sin datos",
    description: "No hemos encontrado datos en este mes."
};